import React, { FC } from 'react';
import styled from 'styled-components';

import { Comments, CommentsProps } from '~/feature/comments/Comments';

export interface ContestCommentsProps extends Pick<CommentsProps, 'targetAuthorId' | 'targetId'> {
}

export const ContestComments: FC<ContestCommentsProps> = (props) => {
  return (
    <SCContestComments>
      <Comments
        targetClass="post"
        {...props}
      />
    </SCContestComments>
  );
};

const SCContestComments = styled.div`
  width: 100%;
  background-color: var(--white-color);
`;
